import { PartnersPageDictionary } from 'types/i18n';

export const partnersPageDictionaryRu: PartnersPageDictionary = {
  titleText: 'Партнеры',
  searchInputPlaceholderText: 'Поиск партнера по ФИО',
};
